import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { selectAnalytics } from "../../../../store/analytics/repository/selector";
import { useDispatch, useSelector } from "react-redux";
import { getUsersActivity } from "../../../../store/analytics/useCases/getUsersActivity/action";

export const useGeneralAnalytics = () => {
    const dispatch = useDispatch();
    const { usersActivity } = useSelector(selectAnalytics);

    // useEffect(()=>{
    //     dispatch(getUsersActivity());
    // }, []);
    
    const [dates, setDates] = useState<{ startDate: Dayjs | null, endDate: Dayjs | null }>({
        startDate: dayjs().startOf('month'),
        endDate: dayjs().endOf('month')
    });

    const handleRangeChange = (selectedDates: [start: Dayjs | null, end: Dayjs | null], dateStrings: [string, string]) => {
        if (selectedDates) {
            const [start, end] = selectedDates;
            setDates({ startDate: start, endDate: end });
        }
    };

    const disabledDate = (current: Dayjs) => {
        if (!current) {
            return false;
        }
        const { startDate, endDate } = dates;
        return false;
    };

    return { dates, handleRangeChange, disabledDate }
};